<div class="form__calendar">
  <input
    #input
    type="text"
    class="form__date text-date-font"
    [ngClass]="{
      'input-white-background': colorOnMovileView === 'WHITE'
    }"
    placeholder="Seleccionar"
    (click)="toogleVisibility()"
    readonly="readonly"
  > <!--  -->
</div>
<div class="calendar-container" #calendar tabindex="0"
(blur)="handleBlur(0)"
(focus)="handleFocus(0)"
  [ngClass]="calendarVisibility ? 'calendar-visible' : 'calendar-invisible' ">
  <div
  class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all date-picker-custom"
  [ngClass]="{
    'calendar-white-background': colorOnMovileView === 'WHITE'
  }"
  > <!-- calendar-white-background -->
    <div [ngClass]="undefinedChecked ? 'blur-enabled' : 'blur-disabled' " >
      <div class="ui-datepicker-header ui-widget-header ui-helper-clearfix ui-corner-all border-top-grey-delegate monthAndYearSelectors no-mr-pd">
        <div class="col-md-7 no-mr-pd">
          <div class="form form--required">
            <select style="height: 40px; padding: 0px 10px;" (click)="handleFocus(1)" (focus)="handleFocus(1)" (blur)="handleBlur(1)" tabindex="-1" [formControl]="asFormControl(selectorsControl.controls.month)">
              <option
                *ngFor="let month of monthsOptions; index as i"
                [value]="i + 1"
                [selected]="i == selectedMonth ? 'selected' : null"
              >
                {{month}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-5 no-mr-pd">
          <div class="form form--required">
            <select style="height: 40px; padding: 0px 10px;"  (click)="handleFocus(2)" (focus)="handleFocus(2)" (blur)="handleBlur(2)" tabindex="-2" [formControl]="asFormControl(selectorsControl.controls.year)">
              <option
                *ngFor="let year of yearsOptions"
                [value]="year"
                [selected]="year == selectedYear ? 'selected' : null"
              >
                {{year}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <table class="ui-datepicker-calendar"
        style="width: 100% !important; max-width: 100% !important; min-width: 100% !important; box-sizing: border-box !important;">
        <thead>
          <tr>
            <th scope="col" class="ui-datepicker-week-end "><span title="Lunes">L</span></th>
            <th scope="col"><span title="Martes">M</span></th>
            <th scope="col"><span title="Miercoles">X</span></th>
            <th scope="col"><span title="Jueves">J</span></th>
            <th scope="col"><span title="Viernes">V</span></th>
            <th scope="col"><span title="Sabado">S</span></th>
            <th scope="col" class="ui-datepicker-week-end"><span title="Domingo">D</span></th>
          </tr>
        </thead>
        <tbody
          style="width: 100% !important; max-width: 100% !important; min-width: 100% !important; box-sizing: border-box !important;">
          <ng-container *ngFor="let week of arrayCalendar; let indexWeek = index">
            <tr>
              <ng-container *ngFor="let day of week; let indexDay = index">
                <td data-handler="selectDay" (click)="handleBlur(3)" [ngClass]="
              {
                'cell': true,
                'ui-datepicker-week-end': indexDay === 0 || indexDay === 6,
                'ui-state-active day-selected': selectedDay === day && selectedYear == currentYear && selectedMonth == displayedMonth && !undefinedChecked,
                'ui-datepicker-other-month ui-datepicker-unselectable ui-state-disabled': !day,
                'ui-state-default ui-state-highlight ui-state-hover': +day === currentDay && selectedYear == currentYear && selectedMonth == currentMonth
              }" class="day-cell ">
                  <a (click)="onDayClicked(+day)" class="day-number link-cell" [ngClass]="{
                  ' day-selected': selectedDay === day && selectedYear == currentYear && selectedMonth == displayedMonth && !undefinedChecked
                }">
                    <div style="position: absolute !important; pointer-events: none; ">{{day}}</div>
                  </a>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div [ngClass]="
    {
      'undefined-check-invisible': !canBeUndefined
    }">
      <div class="ui-widget-header">
      </div>
      <div>
        <div class="form__check u-mt10" style="padding-left: 10px;" (click)="toogleUndefinedChecked()">
          <input type="checkbox" name="example-checkbox" [(ngModel)]="undefinedChecked">
          <label for="newUndefined">
            <div class="fakebox "></div>
            <span style="color: #0b0c0e !important ">Fecha indefinida</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
